<template>
    <div>
        <count-down start="now" end="12:00">
            <div slot-scope="time">
                <div class="row" >
                    <div class="col-xs-12">
                        <div class="alert alert-orbital-shipping text-center">

                            <img src="/img/orbital/icons/truck.svg" class="delivery-truck" alt="A delivery truck">
                            <next-delivery-date>
                                <span slot-scope="{ date }">
                                    Order <span v-if="!isWeekend && (time.hours >= 0 && time.minutes >= 0)">by 12pm</span><span v-else>now</span> and get it by {{ date.format('Do MMMM') }}
                                </span>
                            </next-delivery-date><template v-if="!isWeekend && (time.hours >= 0 && time.minutes >= 0)"> &middot; {{ time.hours }} hours and {{ time.minutes }} minutes remaining</template>
                            <img src="/img/orbital/icons/truck.svg" class="delivery-truck delivery-truck--delay" alt="A delivery truck">
                        </div>
                    </div>
                </div>
            </div>
         </count-down>
    </div>
</template>

<style scoped>
    small {
        display:block;
        font-size:.5em;
        opacity: .7;
    }
</style>
<script>
    import CountDown from './CountDown.vue';

    export default {
        components: {
            CountDown
        },
        data() {
            return {
                today: moment().day(5),
            }
        },
        computed: {
            isWeekend() {
                return (this.today.format('dddd') == "Saturday" || this.today.format('dddd') == 'Sunday');;
            },
            isFriday() {
                return this.today.format('dddd') == 'Friday';
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/SamedayDelivery.vue